import type { ToolCatalogEntry } from './types';
import {
  GENERATED_TOOL_CATALOG,
  GENERATED_DOMAIN_LABELS,
  GENERATED_GOVERNANCE,
  GENERATED_GLOBAL_POLICIES,
} from './generated/toolCatalog.generated';
import type { GeneratedToolAccess } from './generated/toolCatalog.generated';

/**
 * The tool catalog — the read-only projection of the backend ActionRegistry
 * (Surface.TOOL actions), generated by backend/scripts/generate_tool_catalog.py.
 * Code owns existence + signature; the editable overlay (description/level
 * overrides) lands later as a persisted toolset domain.
 */

/** Each entry with its access facts: the modes its authorization takes, and whether it escalates. */
export const TOOL_CATALOG: (ToolCatalogEntry & GeneratedToolAccess)[] = GENERATED_TOOL_CATALOG;

export const DOMAIN_LABELS: Record<string, string> = GENERATED_DOMAIN_LABELS;

/** action_id → the base_policies.cedar rules that govern that tool. */
export const GOVERNANCE = GENERATED_GOVERNANCE;

/** Broad walls/wildcards (JIT, super-admin and other cross-cutting rules) that apply across all tools. */
export const GLOBAL_POLICIES = GENERATED_GLOBAL_POLICIES;

/** action_ids that can never be narrowed out (runtime hooks depend on them).
 *  Not yet modelled in the backend — empty until a `protected` source exists. */
export const PROTECTED_ACTION_IDS = TOOL_CATALOG.filter((e) => e.protected).map((e) => e.actionId);

/** Filter helper shared by the managed store and consumers. */
export function filterForAgentType(
  entries: ToolCatalogEntry[],
  agentType: 'investigation' | 'automation' | 'both',
): ToolCatalogEntry[] {
  return entries.filter((e) => {
    if (e.investigationOnly && agentType === 'automation') return false;
    if (e.automationOnly && agentType === 'investigation') return false;
    return true;
  });
}
